import React, { ChangeEvent, useCallback, useEffect, useRef, useState } from "react";
import { useFeatures } from "./hooks/usePermissions";
import { filterEsgParamsForPlan } from "./utils/features";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import * as XLSX from "xlsx";
import _ from "lodash";
import FormData from "form-data";
import { BlobServiceClient } from "@azure/storage-blob";
import Swal from "sweetalert2";
import toast, { Toaster } from "react-hot-toast";
import Dropzone from "react-dropzone";
import { Avatar, Backdrop, Badge, Box, Button, CircularProgress, Grid, InputLabel, MenuItem, OutlinedInput, Paper, Select, Step, StepContent, StepLabel, Stepper, Typography } from "@mui/material";
import CloudUploadTwoToneIcon from "@mui/icons-material/CloudUploadTwoTone";
import clsx from "clsx";
import containerTheme from "./theme/containerTheme.js";
import AADHeader from "./components/AADHeader.js";
import LoginHeader from "./components/LoginHeader.js";
import SideNavigation from "./components/SideNavigation.js";
import { Dropdown } from "primereact/dropdown";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Modal from "react-bootstrap/Modal";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { Checkbox } from "primereact/checkbox";
import { InputText } from "primereact/inputtext";
import { RadioButton } from "primereact/radiobutton";
import { disambiguateSourceLabel } from "./utils/sourceLabelDisplay";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const Icon1 = "./assets/img/Assets/configration_icon/White/1.png";
const Icon2 = "./assets/img/Assets/configration_icon/White/2.png";
const Icon3 = "./assets/img/Assets/configration_icon/White/3.png";
const Icon4 = "./assets/img/Assets/configration_icon/White/4.png";
const Icon5 = "./assets/img/Assets/configration_icon/White/5.png";
const customIcons = [Icon1, Icon2, Icon3, Icon4, Icon5];

const iconDotInactive = "./assets/img/Assets/configration_icon/Teal Green/Ellipse 61.png";
const iconBackgroundInactive = "./assets/img/Assets/configration_icon/Teal Green/Ellipse 59.png";
const steps = [
  {
    label: "Select ESG Parameter",
    description: ``,
    active: 1,
  },
  {
    label: "Edit Data Connectors",
    description: "",
    active: 2,
  },
  {
    label: "Edit/ Create Connection",
    description: "",
    active: 3,
  },
  {
    label: "Edit Field Mapping",
    description: "",
    active: 4,
  },
  {
    label: "Review & Finish",
    description: "",
    active: 5,
  },
];

export default function EditConfig(props) {
  // const classes = useStyles(props);
  const navigate = useNavigate();
  // Plan drives which ESG parameters a trial may configure (staff/loading = full list).
  const { plan: _rawPlan, staff: _staff, loading: _planLoading } = useFeatures();
  const orgPlan = _staff || _planLoading ? "standard" : _rawPlan;
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 768);
  const [selectedOptions, setSelectedOptions] = useState([]);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  const isOptionDisabled = (option) => {
    return selectedOptions.includes(option);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsSidebarOpen(false); // Close sidebar on mobile
      } else {
        setIsSidebarOpen(true); // Open sidebar on larger screens
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [count, setCount] = useState(1);
  const [activeStep, setActiveStep] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [myloading, setMyLoading] = React.useState(false);
  const [apiDone, setApiDone] = React.useState(false);
  const [result, setResult] = React.useState({});
  const [selectedExcel, setSelectedExcel] = useState("");
  const [showTable, setShowTable] = React.useState(false);
  const [businessunit, setBusinessUnit] = React.useState(false);
  const [modules, setModules] = React.useState(false);
  const [mymodule, setMyModule] = useState("");
  const [importfile, setImportFile] = React.useState("");
  const [importpdffile, setImportPDFFile] = React.useState("");
  const [azureAPIMessage, setAzureAPIMessage] = React.useState("");
  const [excelfields, setFields] = React.useState(false);
  const [headerfields, setHeaderFields] = React.useState([]);
  const [pdffields, setPDFFields] = React.useState(false);
  const [pdfSourceLabels, setPdfSourceLabels] = React.useState({});
  const [apifields, setAPIFields] = React.useState(false);
  const [dynamicsfields, setDynamicsFields] = React.useState(false);
  const [azureTableStoragefields, setAzureTableStorageFields] = React.useState(false);
  const [pattern, setPattern] = useState("");
  const [sitelocation, setSiteLocation] = useState("");
  const [activeSiteLocation, setActiveSiteLocation] = useState([]);
  const [sitelocation1, setSiteLocation1] = useState("");
  const [leftheader, setLeftHeader] = useState("");
  const [rightheader, setRightHeader] = useState("");
  const [connectors, setConnectors] = useState("");
  const [matrics, setMatrics] = useState("");
  const [mymatrics, setMyMatrics] = useState("");
  const [getappnames, setAppNames] = useState("");
  const [apikey, setApiKey] = useState("");
  const [apivalue, setApiValue] = useState("");
  const [resource, setResource] = useState("");
  const [accesstokenurl, setAccessTokenUrl] = useState("");
  const [clientid, setClientID] = useState("");
  const [clientsecret, setClientSecret] = useState("");
  const [scope, setScope] = useState("");
  const [tenantid, setTenantID] = useState("");
  const [query, setQuery] = useState("");
  const [accountname, setAccoutName] = useState("");
  const [tablename, setTableName] = useState("");
  const [apiclientid, setApiClientId] = useState("");
  const [apisubclientid, setApiSubClientId] = useState("");
  const [hash, setHash] = useState("");
  const companyid = localStorage.getItem("companyid");
  const [selectedConnectors, setSelectedConnectors] = useState([]);
  const [esg, setESG] = useState("");
  const [esgParameter, setESGParameter] = useState("");
  const [topic, setTopic] = useState("");
  const [subTopic, setSubTopic] = useState("");
  const [listESGParameter, setListESGParameter] = useState([]);
  const esgParamOptions = filterEsgParamsForPlan(listESGParameter || [], orgPlan).map((item) => ({ label: item, value: item }));
  const [listESG, setListESG] = useState([]);
  const esgOptions = listESG?.map((item) => ({ label: item, value: item }));
  const [listTopic, setListTopic] = useState([]);
  const topicOptions = listTopic?.map((item) => ({ label: item, value: item }));
  const [listSubTopic, setListSubTopic] = useState([]);
  const subTopicOptions = listSubTopic?.map((item) => ({ label: item, value: item }));
  const [selectedDiv, setSelectedDiv] = useState(null);
  const [parameterOption, setParameterOption] = useState(null); // 'site' or 'legal'
  const [legalEntity, setLegalEntity] = useState("");
  const [listLegalEntity, setListLegalEntity] = useState([]);

  const legalEntityOptions = listLegalEntity?.map((item) => ({
    label: item.name,
    value: item.name,
  }));

  const frequencyOptions = [
    { label: "Weekly", value: "Weekly" },
    { label: "Monthly", value: "Monthly" },
  ];
  const [dataFrequency, setDataFrequency] = useState(null);
  const siteLocationOptions = activeSiteLocation?.map((site) => ({
    label: site.name,
    value: site.name,
  }));
  const [formData, setFormData] = useState({
    connectionType: "",
    accountName: "",
    query: "",
    storageAccountName: "",
    tableName: "",
    key: "",
    value: "",
    resourceUrl: "",
    accessTokenURL: "",
    clientId: "",
    clientSecret: "",
    scope: "",
    tenantId: "",
    message: "",
  });
  const cardStyles = {
    heading: {
      marginLeft: "15px",
      marginBottom: "10px",
    },
  };

  const allFieldOptions = [...(headerfields.length ? [{ label: "Excel Headers", items: headerfields.map((h) => ({ label: h, value: h })) }] : []), ...(azureTableStoragefields.length ? [{ label: "Azure Table Headers", items: azureTableStoragefields.map((h) => ({ label: h, value: h })) }] : [])];

  // Replace your existing validateRequiredFields() with this implementation:
  const validateRequiredFields = () => {
    // Check all required fields have a connector selected
    const invalidFields = excelfields.reduce((acc, field, idx) => {
      if (field.value === true && (!selectedConnectors[idx] || selectedConnectors[idx] === "")) {
        acc.push(field.key);
      }
      return acc;
    }, []);

    if (invalidFields.length > 0) {
      Swal.fire({
        icon: "error",
        iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
        title: "Required Fields Missing",
        text: `Please select connectors for: ${invalidFields.join(", ")}`,
      });
      return false;
    }

    return true;
  };

  const handleNext = () => {
    setSelectedDiv(null);
    setCount((prevCount) => prevCount + 1);
    if (activeStep === 0) {
      console.log("activeStep: ", activeStep);
    }
    if (activeStep === 1) {
      fetchFields();
      console.log("fetchfields: ", excelfields);
    }
    if (activeStep === 3) {
      // New validation logic for required fields
      const farray = [];
      for (let i = 0; i < excelfields.length; i++) {
        const field = excelfields[i];
        const isRequired = field.value === true;
        const fieldName = field.key.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/^./, (str) => str.toUpperCase());
        const selectedValue = selectedOptions[i];
        if (isRequired && (!selectedValue || selectedValue === "")) {
          farray.push(fieldName);
        }
      }
      if (farray.length > 0) {
        Swal.fire({
          icon: "error",
          iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
          title: "Oops...",
          text: "Fields required are " + farray.join(", "),
        });
        return false;
      }
      console.log("Matrics: ", matrics);
      console.log("MyModule: ", mymodule);
      console.log("RightHeader: ", rightheader);
      console.log("Connectors: ", connectors);
      console.log("Trying to render:", JSON.stringify(mymodule));
    }
    if (activeStep === 3) {
      var inps = document.getElementsByName("destination[]");
      //console.log("inps: ", inps);
      let destination = [];
      for (var i = 0; i < inps.length; i++) {
        var inp = inps[i];
        destination.push(inp.value);
      }
      setRightHeader(destination);
      var inps1 = document.getElementsByName("excelHeaders[]");
      let excelHeaders1 = [];
      for (var i = 0; i < inps1.length; i++) {
        var inp1 = inps1[i];
        excelHeaders1.push(inp1.value);
      }
      setLeftHeader(excelHeaders1);
      var cons1 = document.getElementsByName("connector[]");
      let connectors = [];
      for (var i = 0; i < cons1.length; i++) {
        var con1 = cons1[i];
        connectors.push(con1.value);
      }
      setConnectors(connectors);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    console.log("Neeraj activeStep: ", activeStep);
  };

  const handleBackConfig = () => {
    setShowTable(false);
  };

  const handleBack = () => {
    setSelectedDiv(null);
    setCount((prevCount) => prevCount - 1);
    const currentstep = activeStep;
    if (currentstep === 2) {
      setImportFile("");
    }
    if (currentstep === 3) {
    }
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };
  const [personName, setPersonName] = React.useState([]);

  const username = localStorage.getItem("userName");
  var myHeaders = new Headers();
  myHeaders.append("username", username);

  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  const handleESGChange = (value, setMyModule) => {
    if (value == "") {
      setMyMatrics("");
      setMatrics("");
      setMyModule("");
    } else {
      setMyModule(value);
      fetchESGMatrics(value);
    }
  };

  async function checkAppName1(site) {
    console.log(site);
    if (matrics !== "" && site !== "") {
      var CHeaders = new Headers();
      CHeaders.append("username", username);
      CHeaders.append("esg", matrics);
      CHeaders.append("site", site);

      var Options = {
        method: "GET",
        headers: CHeaders,
        redirect: "follow",
      };

      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}get-allappname`, Options);
        if (response.status === 200) {
          const responseJson = await response.json();
          if (responseJson.success == false) {
          } else if (responseJson.status == 400) {
          } else {
            var data = responseJson.data;
            setAppNames(data);
          }
        } else {
        }
      } catch (error) {
        console.error(error);
      }
    }
  }

  async function checkAppName2(matrics) {
    if (topic !== "" && sitelocation1 !== "") {
      var CHeaders = new Headers();
      CHeaders.append("username", username);
      CHeaders.append("esg", topic);
      CHeaders.append("site", sitelocation1);

      var Options = {
        method: "GET",
        headers: CHeaders,
        redirect: "follow",
      };

      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}get-allappname`, Options);
        if (response.status === 200) {
          const responseJson = await response.json();
          if (responseJson.success == false) {
          } else if (responseJson.status == 400) {
          } else {
            var data = responseJson.data;
            setAppNames(data);
          }
        } else {
        }
      } catch (error) {
        console.error(error);
      }
    }
  }

  async function fetchSiteLocation() {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}list-sitelocation`, requestOptions);
      if (response.status === 200) {
        const responseJson = await response.json();
        if (responseJson.success == false) {
          setSiteLocation("");
        } else if (responseJson.status == 400) {
          setSiteLocation("");
        } else {
          setSiteLocation(responseJson);
          setActiveSiteLocation(responseJson.data.filter((item) => item.isActive === true));
        }
      } else {
        setSiteLocation("");
      }
    } catch (error) {
      console.error(error);
    }
  }

  async function fetchLegalEntities() {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}list-entities`, requestOptions);
      if (response.status === 200) {
        const responseJson = await response.json();
        if (responseJson.success == false) {
          setListLegalEntity("");
        } else if (responseJson.status == 400) {
          setListLegalEntity("");
        } else {
          setListLegalEntity(responseJson.data.filter((item) => item.isActive === true));
          console.log(responseJson.data.filter((item) => item.isActive === true));
        }
      } else {
        setListLegalEntity("");
      }
    } catch (error) {
      console.error(error);
    }
  }

  async function fetchESG() {
    const username = localStorage.getItem("userName");
    const myHeaders = new Headers();
    myHeaders.append("username", username);
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({
        esg: [""],
        esgParameter: [""],
        topic: [""],
        subTopic: [""],
      }), // Add body here, pass any needed data
      redirect: "follow",
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}get-configuration-parameter`, requestOptions);
      if (response.status === 200) {
        const responseJson = await response.json();
        if (responseJson.success === false || responseJson.status === 400) {
          setListESG("");
        } else {
          setListESG(responseJson.esg);
        }
      } else {
        setListESG("");
      }
    } catch (error) {
      console.error(error);
    }
  }

  async function fetchESGParameter(e) {
    const username = localStorage.getItem("userName");
    const myHeaders = new Headers();
    myHeaders.append("username", username);
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({
        esg: [e],
        esgParameter: [""],
        topic: [""],
        subTopic: [""],
      }), // Add body here, pass any needed data
      redirect: "follow",
    };

    try {
      setLoading(true);
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}get-configuration-parameter`, requestOptions);
      if (response.status === 200) {
        const responseJson = await response.json();
        if (responseJson.success === false || responseJson.status === 400) {
          setLoading(false);
          setListESGParameter("");
        } else {
          setLoading(false);
          setListESGParameter(responseJson.esgParameter);
        }
      } else {
        setLoading(false);
        setListESGParameter("");
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  }

  async function fetchTopic(e) {
    const username = localStorage.getItem("userName");
    const myHeaders = new Headers();
    myHeaders.append("username", username);
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({
        esg: [esg],
        esgParameter: [e],
        topic: [""],
        subTopic: [""],
      }), // Add body here, pass any needed data
      redirect: "follow",
    };

    try {
      setLoading(true);
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}get-configuration-parameter`, requestOptions);
      if (response.status === 200) {
        const responseJson = await response.json();
        if (responseJson.success === false || responseJson.status === 400) {
          setLoading(false);
          setListTopic("");
        } else {
          setLoading(false);
          setListTopic(responseJson.topic);
        }
      } else {
        setLoading(false);
        setListTopic("");
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  }

  async function fetchSubTopic(e) {
    const username = localStorage.getItem("userName");
    const myHeaders = new Headers();
    myHeaders.append("username", username);
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({
        esg: [esg],
        esgParameter: [esgParameter],
        topic: [e],
        subTopic: [""],
      }), // Add body here, pass any needed data
      redirect: "follow",
    };

    try {
      setLoading(true);
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}get-configuration-parameter`, requestOptions);
      if (response.status === 200) {
        const responseJson = await response.json();
        if (responseJson.success === false || responseJson.status === 400) {
          setLoading(false);
          setListSubTopic("");
        } else {
          setLoading(false);
          setListSubTopic(responseJson.subTopic);
        }
      } else {
        setLoading(false);
        setListSubTopic("");
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  }

  async function fetchESGMatrics(value) {
    try {
      var myHeaderss = new Headers();
      myHeaderss.append("username", username);
      myHeaderss.append("param", value);
      var requestOptionss = {
        method: "GET",
        headers: myHeaderss,
        redirect: "follow",
      };
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}ESG`, requestOptionss);
      const data = await response.json();
      setMyMatrics(data);
    } catch (error) {
      console.error(error);
    }
  }

  async function fetchOrganization() {
    try {
      var myHeaderss = new Headers();
      myHeaderss.append("username", username);
      var requestOptionss = {
        method: "GET",
        headers: myHeaderss,
        redirect: "follow",
      };
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}organization-name`, requestOptionss);
      const data = await response.json();
      setApiClientId("Ecoprism");
      setApiSubClientId(data.data.name);
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    fetchESG();
    fetchSiteLocation();
    fetchLegalEntities();
    fetchOrganization();
  }, [activeStep]);

  async function fetchModules() {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}list-modules`);
      if (response.status === 200) {
        const responseJson = await response.json();
        if (responseJson.success == false) {
          setModules("");
        } else if (responseJson.status == 400) {
          setModules("");
        } else {
          setModules(responseJson.data);
        }
      } else {
        setModules("");
      }
    } catch (error) {
      console.error(error);
    }
  }
  useEffect(() => {
    fetchModules();
  }, []);

  async function fetchFields() {
    try {
      var myH = new Headers();
      myH.append("username", username);
      myH.append("modulename", mymodule);
      myH.append("pattern", selectedExcel);
      myH.append("ESGMetric", topic);
      var requestO = {
        method: "GET",
        headers: myH,
        redirect: "follow",
      };
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}get-fields`, requestO);
      const data = await response.json();
      const inputList = data.data;
      setFields(inputList);
      function combine(collections) {
        const entries = [...Object.entries(collections)];
        const length = entries[0]?.[1]?.length ?? 0;
        const result = [];
        for (const [name, array] of entries) {
          if (array.length !== length) throw new Error("Non-uniform array lengths");
          for (let i = 0; i < length; i += 1) {
            const item = (result[i] ??= {});
            item[name] = array[i];
          }
        }
        return result;
      }
      const values = Object.values(inputList);
      const keys = Object.keys(inputList);
      const merge = () => {
        const merged = combine({
          value: values,
          key: keys,
        });
        setFields(merged);
      };
      merge();
    } catch (error) {
      console.error(error);
    }
  }

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  async function uploadFileName(filename, esgMetric) {
    setMyLoading(true);
    const res = await fetch(`${process.env.REACT_APP_BASE_API_URL}GetPdfParameterAsync`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        fileName: filename,
        esgMetric: esgMetric,
        userEmail: username,
      }),
    });
    if (res.status === 200) {
      const responseJson = await res.json();
      if (responseJson.success == false) {
        setMyLoading(false);
        Swal.fire({
          icon: "error",
          iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
          title: "Oops...",
          text: responseJson.data,
        });
      } else if (responseJson.status == 400) {
        setMyLoading(false);
        Swal.fire({
          icon: "error",
          iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
          title: "Oops...",
          text: responseJson.title,
        });
      } else {
        function combine(collections) {
          const entries = [...Object.entries(collections)];
          const length = entries[0]?.[1]?.length ?? 0;
          const result = [];
          for (const [name, array] of entries) {
            if (array.length !== length) throw new Error("Non-uniform array lengths");
            for (let i = 0; i < length; i += 1) {
              const item = (result[i] ??= {});
              item[name] = array[i];
            }
          }
          return result;
        }
        const extractedData = responseJson.data?.extractedData ?? responseJson.data;
        const businessUnitValues = Object.values(extractedData);
        const businessUnitKeys = Object.keys(extractedData || {});
        const merge = () => {
          const merged = combine({
            businessunitvalue: businessUnitValues,
            businessunit: businessUnitKeys,
          });
          const businessunitvalues = merged.map((item) => item.businessunit);
          const commaSeparatedArray = businessunitvalues.join(",");
          const dataArray = commaSeparatedArray.split(",");
          setPDFFields(dataArray);
          const fmmEc = responseJson.data?.fieldMappingMetadata;
          if (fmmEc) {
            const sm = {};
            Object.entries(fmmEc).forEach(([k, v]) => { if (v?.sourceField) sm[k] = v.sourceField; });
            setPdfSourceLabels(sm);
          }
          setMyLoading(false);
          Swal.fire({
            icon: "success",
            html: filename + " uploaded successfully",
            iconHtml: '<img src="assets/img/successicon.png" style="width: 55px; height: 55px;" />',
          });
        };

        merge();
        setImportPDFFile(filename);
      }
    } else {
      setMyLoading(false);
      Swal.fire({
        icon: "error",
        iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
        title: "Oops...",
        text: "Pdf Not uploaded",
      });
    }
  }

  //PDF Code
  async function uploadImage(containerName, file) {
    let res = await fetch(`${process.env.REACT_APP_BASE_API_URL}GetSASToken`, {
      method: "GET",
    });
    if (res.status === 200) {
      const responseJson = await res.json();
      const connectionString = responseJson.data;
      const blobServiceClient = new BlobServiceClient(connectionString);
      const containerClient = blobServiceClient.getContainerClient(containerName);
      const blobClient = containerClient.getBlobClient(file.name);
      const blockBlobClient = blobClient.getBlockBlobClient();
      const result = await blockBlobClient.uploadBrowserData(file, {
        blockSize: 4 * 1024 * 1024,
        concurrency: 20,
        onProgress: (ev) => console.log(ev),
      });
      if (result) {
        console.log(file.name);
        uploadFileName(file.name, topic);
      }
    } else {
    }
  }

  const onDrop = useCallback((acceptedFiles) => {
    setMyLoading(true);
    //const type = localStorage.getItem('type');
    const type = JSON.parse(localStorage.getItem("type"));
    const name = acceptedFiles[0].name;
    const extension = name.split(".").pop();

    // Check if the file extension is allowed
    const allowedExtensions = {
      Excel: ["xls", "xlsx"],
    };

    const allowedExtensionsPdf = {
      PDF: ["pdf"],
    };

    // Get allowed extensions based on selected connector type
    const selectedType = type.find((t) => allowedExtensions[t]);
    const allowedExts = selectedType ? allowedExtensions[selectedType] : [];

    const selectedTypePdf = type.find((t) => allowedExtensionsPdf[t]);
    const allowedExtsPdf = selectedTypePdf ? allowedExtensionsPdf[selectedTypePdf] : [];

    let sendObj = {
      startDate: "",
      endDate: "",
      energyCons: 0,
    };
    if (Array.isArray(type) && type.includes("Excel") && allowedExts.includes(extension)) {
      if (extension === "xls" || extension === "xlsx") {
        acceptedFiles.forEach((file) => {
          const reader = new FileReader();
          reader.onload = (evt) => {
            // evt = on_file_select event
            /* Parse data */
            const bstr = evt.target.result;
            const wb = XLSX.read(bstr, { type: "binary" });
            /* Get first worksheet */
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            /* Convert array of arrays */
            const data = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], { raw: true });
            //const workbookHeaders = XLSX.readFile(bstr, { sheetRows: 1 });
            if (data.length === 0) {
              setMyLoading(false);
              Swal.fire({
                icon: "error",
                iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
                title: "Oops...",
                text: "Excel File is not proper or header is not present",
              });
              return false;
              // Perform actions for an empty array
            }
            setImportFile(acceptedFiles[0].name);
            setMyLoading(false);
            Swal.fire({
              icon: "success",
              html: acceptedFiles[0].name + " uploaded successfully",
              iconHtml: '<img src="assets/img/successicon.png" style="width: 55px; height: 55px;" />',
            });
            const columnsArray = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames], {
              header: 1,
            })[0];
            setHeaderFields(columnsArray);
            var result = columnsArray
              .map(function (val) {
                return val;
              })
              .join(",");
            var item = "";
            var results = {};

            if (result !== null) {
              result = result.split(",");

              for (var i = 0; i < result.length; i++) {
                item = result[i].trim();

                results[item] = item;
              }
            }
            /* Update state */
            const jsonData = JSON.parse(JSON.stringify(data));
            const newdata = [];
            _.forEach(jsonData, (jd) => {
              sendObj.energyCons = jd.EnergyConsumption;
              sendObj.startDate = jd.StartDate;
              sendObj.endDate = jd.EndDate;
              newdata.push({
                email: "sudies@ecoprism.com",
                energy: sendObj.energyCons,
                region: "DK",
                reportPeriod: 2,
                endTimeEpoch: sendObj.endDate,
                unit: "kWh",
              });
            });
            setMyLoading(false);
          };
          reader.readAsBinaryString(file);
        });
      } else {
        setMyLoading(false);
        Swal.fire({
          icon: "error",
          iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
          title: "Oops...",
          text: "File format is not valid",
        });
        setImportFile();
        return false;
      }
    }
    if (Array.isArray(type) && type.includes("PDF") && allowedExtsPdf.includes(extension)) {
      if (extension === "pdf") {
        uploadImage("ecoprismfilecontainer", acceptedFiles[0]);
      } else {
        setMyLoading(false);
        Swal.fire({
          icon: "error",
          iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
          title: "Oops...",
          text: "File format is not valid",
        });
        setImportFile();
        return false;
      }
    }
  }, []);

  const processExcel = async (newdata) => {
    try {
      const requestOptions = newdata;
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}upload-file`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestOptions),
      });
      const data = await response.json();
      setMyLoading(false);
      setApiDone(true);
      setResult(data);
      setHeaderFields(data);
      setActiveStep(2);
    } catch (error) {}
  };

  const uploadExcel = async (newdata) => {
    try {
      const requestOptions = newdata;
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}file`, {
        method: "POST",
        body: requestOptions,
      });
      const data = await response.json();
      setMyLoading(false);
      setApiDone(true);
      setResult(data);
      setHeaderFields(data);
      setActiveStep(2);
    } catch (error) {}
  };

  const excelH = async (e, i) => {
    document.getElementById("excel" + i).value = e;
    const updatedSelections = [...selectedOptions];
    updatedSelections[i] = e;
    setSelectedOptions(updatedSelections);
  };

  const connector = async (e, i) => {
    document.getElementById("connector" + i).value = e;
  };

  useEffect(() => {
    // If there are selected Excel files, but no selected div, select the first Excel file
    if (selectedExcel.length > 0 && selectedDiv === null) {
      setSelectedDiv(selectedExcel[0]);
    }
  }, [selectedExcel, selectedDiv]);

  const handleDivClick = (divName) => {
    console.log(divName);
    if (selectedExcel.includes(divName)) {
      setSelectedDiv(divName);
    } else {
      setSelectedDiv(null);
    }
  };

  /* For the connectors multiple selection */
  const handleClick = (item) => {
    const updatedSelection = [...selectedExcel];

    // Toggle the selection
    if (updatedSelection.includes(item)) {
      updatedSelection.splice(updatedSelection.indexOf(item), 1);
    } else {
      updatedSelection.push(item);
    }

    localStorage.setItem("type", JSON.stringify(updatedSelection));
    setSelectedExcel(updatedSelection);
  };

  useEffect(() => {
    if (!selectedExcel || selectedExcel.length === 0) {
      setSelectedConnectors(""); // Reset when empty
    } else {
      const selectedConnectors = selectedExcel
        .map((item) => String(item).replace(/\s+/g, "")) // Convert to string & remove spaces
        .join(", ");

      setSelectedConnectors(selectedConnectors);
    }
  }, [selectedExcel]);

  const [showDefaultModal, setShowDefaultModal] = useState(false);

  const handleOpenDefaultModal = (rowData) => {
    setCurrentDefaultRow(rowData);
    setShowDefaultModal(true);
  };
  const handleCloseDefaultModal = () => setShowDefaultModal(false);
  const handleSaveDefaultValue = () => {
    // grab value from your input (e.g. via ref or controlled state)
    // ...save logic...
    setShowDefaultModal(false);
    // optionally show a toast / Snackbar here
  };

  const containerRef = useRef();
  const getCurrentISODate = () => {
    const now = new Date();
    return now.toISOString(); // Returns the current date and time in ISO 8601 format
  };

  let handleSubmit = async (e) => {
    setMyLoading(true);
    e.preventDefault();
    // Merging the arrays
    const mergedArray = rightheader.map((right, index) => ({
      leftHeader: right,
      rightHeader: businessunit[index],
      centerHeader: connectors[index],
    }));
    // Function to filter the mergedArray and build the fieldMapping based on connector type
    const buildConnectorsData = (selectedExcel) => {
      return selectedExcel.map((item) => {
        // Filter mergedArray for Excel or Azure Table Storage based on centerHeader
        const fieldMapping = mergedArray
          .filter((mapItem) => mapItem.centerHeader === item) // Filter by type (Excel or Azure)
          .reduce((acc, mapItem) => {
            acc[mapItem.leftHeader] = mapItem.rightHeader; // Map leftHeader to rightHeader
            return acc;
          }, {});

        // Return the structure based on type
        if (item === "Excel") {
          return {
            type: item,
            identifier: "xyz",
            fieldMapping,
            defaultMappings: {},
            clientId: "Ecoprism",
            subClientId: "Ecoprism123",
            connectionHash: "2a8bea04931fc50c68083c337a796da38cb371183a91b2f3803ae1011a98",
            connectionFeedTopic: "abcd",
            connectionFeedTopicSecretKv: "83c337a796da38cb371183a91b2f",
          };
        } else if (item === "Azure Table Storage") {
          return {
            type: item,
            identifier: "xyz",
            authMethod: "OAuth",
            authDetails: {
              type: "OAuth",
              AccessTokenUrl: accesstokenurl,
              ClientId: clientid,
              ClientSecret: clientsecret,
              Scope: scope,
              TenantId: tenantid,
            },
            storageAccountName: accountname,
            ResourceUrl: resource,
            tableName: tablename,
            query: query,
            fieldMapping, // Add the fieldMapping here as well
            defaultMappings: {},
            HttpMethod: "POST",
          };
        } else if (item === "API") {
          return {
            type: item,
            identifier: "xyz",
            authMethod: "API",
            authDetails: {
              Key: apikey,
              Value: apivalue,
            },
            ResourceUrl: resource,
            query: query,
            clientid: apiclientid,
            subclientid: apisubclientid,
            fieldMapping, // Add the fieldMapping here as well
            defaultMappings: {},
            HttpMethod: "POST",
          };
        }
      });
    };

    // Call the function to build connectors data
    const connectorsData = buildConnectorsData(selectedExcel);

    const formattedString = selectedExcel.map((item) => item.replace(/\s+/g, "")).join("");

    try {
      let res = await fetch(`${process.env.REACT_APP_BASE_API_URL}SaveCompositeConnectorConfig`, {
        method: "POST",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          username: username,
        },
        body: JSON.stringify({
          siteLocationId: sitelocation1,
          legalEntity: legalEntity,
          companyId: companyid,
          name: formattedString,
          module: "abcde",
          esg: esg,
          esgMetric: esgParameter,
          connectors: connectorsData,
          topic: topic,
          subTopic: subTopic,
          schedule: {
            frequency: dataFrequency,
            timeOfDay: "14:00",
            daysOfWeek: ["Monday", "Wednesday", "Friday"],
            dayOfMonth: 15,
            specificDateTime: getCurrentISODate(),
          },
          createdAt: getCurrentISODate(),
          updatedAt: getCurrentISODate(),
          isActive: true,
        }),
      });
      if (res.status === 200) {
        const responseJson = await res.json();
        if (responseJson.success == false) {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: responseJson.data,
          });
        } else if (responseJson.status == 400) {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: responseJson.title,
          });
        } else {
          setMyLoading(false);
          // Show success popup, then redirect
          Swal.fire({
            icon: "success",
            html: '<h4 style="color:#407775;font-size: 20px;">Success!</h4><p style="font-size:16px;">Connection Created successfully</p>',
            iconHtml: '<img src="assets/img/successicon.png" style="width: 55px; height: 55px;" />',
            confirmButtonText: "OK",
          }).then(() => {
            navigate("/allconfiguration");
          });
        }
      }
    } catch (err) {
      setMyLoading(false);
      console.log(err);
    }
  };
  const [isNextDisabled, setIsNextDisabled] = useState(true);
  const handleCancel = () => {
    setActiveStep(0); // Reset the active step to 0
  };

  const [connectionType, setConnectionType] = useState("");
  const connectionTypeOptions = [
    { label: "OAuth", value: "OAuth" },
    { label: "API Key", value: "APIkey" },
  ];

  const handleConnectionTypeChange = (e) => {
    setConnectionType(e.target.value);
  };

  const checkApiConnection = async (type) => {
    setMyLoading(true);

    try {
      let res;
      if (type === "APIKey") {
        console.log(type);
        console.log(formData);
        if (formData.key === "") {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: "Enter API Key",
          });
        }
        if (formData.value === "") {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: "Enter Value Here",
          });
        }
        if (formData.resourceUrl === "") {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: "Enter Resource Url",
          });
        }
        res = await fetch(`${process.env.REACT_APP_BASE_API_URL}checkApiConnection`, {
          method: "POST",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            username: username,
            key: formData.key,
            value: formData.value,
            resource: formData.resourceUrl,
          },
          body: JSON.stringify({
            ConnectorName: "API",
            authMethod: "APIKey",
            authDetails: {
              Key: formData.key,
              Value: formData.value,
            },
            ResourceUrl: formData.resourceUrl,
          }),
        });
      } else {
        if (formData.clientid === "") {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: "Enter client id",
          });
        }
        if (formData.clientsecret === "") {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: "Enter client secret",
          });
        }
        if (formData.scope === "") {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: "Enter scope",
          });
        }
        if (formData.accesstokenurl === "") {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: "Enter access token url",
          });
        }
        if (formData.tenantid === "") {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: "Enter tenant id",
          });
        }
        if (formData.resource === "") {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: "Enter resource urls",
          });
        }
        res = await fetch(`${process.env.REACT_APP_BASE_API_URL}checkApiConnection`, {
          method: "POST",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            username: username,
          },
          body: JSON.stringify({
            ConnectorName: "API",
            authMethod: "OAuth",
            authDetails: {
              type: "OAuth",
              AccessTokenUrl: formData.accesstokenurl,
              ClientId: formData.clientid,
              ClientSecret: formData.clientsecret,
              Scope: formData.scope,
              TenantId: formData.tenantid,
            },
            storageAccountName: formData.accountname,
            ResourceUrl: formData.resourceUrl,
            tableName: formData.tablename,
            query: formData.query,
          }),
        });
      }

      if (res.status === 200) {
        const responseJson = await res.json();
        if (responseJson === true) {
          let res1;
          if (type === "APIkey") {
            res1 = await fetch(`${process.env.REACT_APP_BASE_API_URL}getapifields`, {
              method: "POST",
              headers: {
                "Content-type": "application/json; charset=UTF-8",
                username: username,
                key: formData.key,
                value: formData.value,
                resource: formData.resourceUrl,
              },
              body: JSON.stringify({
                ConnectorName: "API",
                authMethod: "APIKey",
                authDetails: {
                  Key: formData.key,
                  Value: formData.value,
                },
                ResourceUrl: formData.resourceUrl,
              }),
            });
          } else {
            res1 = await fetch(`${process.env.REACT_APP_BASE_API_URL}getapifields`, {
              method: "POST",
              headers: {
                "Content-type": "application/json; charset=UTF-8",
                username: username,
                key: formData.key,
                value: formData.value,
                resource: formData.resourceUrl,
              },
              body: JSON.stringify({
                ConnectorName: "API",
                authMethod: "OAuth",
                authDetails: {
                  type: "OAuth",
                  AccessTokenUrl: formData.accesstokenurl,
                  ClientId: formData.clientid,
                  ClientSecret: formData.clientsecret,
                  Scope: formData.scope,
                  TenantId: formData.tenantid,
                },
                storageAccountName: formData.accountname,
                ResourceUrl: formData.resourceUrl,
                tableName: formData.tablename,
                query: formData.query,
              }),
            });
          }
          if (res1.status === 200) {
            const responseJson1 = await res1.json();
            if (responseJson1.success == false) {
              setMyLoading(false);
              Swal.fire({
                icon: "error",
                iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
                title: "Oops...",
                text: responseJson.data,
              });
            } else if (responseJson1.status == 400) {
              setMyLoading(false);
              Swal.fire({
                icon: "error",
                iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
                title: "Oops...",
                text: responseJson.title,
              });
            } else {
              setMyLoading(false);
              Swal.fire({
                icon: "success",
                html: '<h4 style="color:#407775;font-size: 20px;">Success!</h4><p style="font-size:16px;">Connection Created successfully</p>',
                iconHtml: '<img src="assets/img/successicon.png" style="width: 55px; height: 55px;" />',
              });
              if (type === "APIkey") {
                setAPIFields(responseJson1);
              }
              if (type === "OAuth") {
                setAPIFields(responseJson1);
              }
            }
          }
        } else {
          setMyLoading(false);
          setAzureAPIMessage("");
        }
      } else {
        setMyLoading(false);
      }
    } catch (err) {
      setMyLoading(false);
    }
  };

  const checkAzureConnection = async (selectedExcel) => {
    setMyLoading(true);
    try {
      let res;
      if (selectedExcel === "APIKey") {
        if (apikey === "") {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: "Enter API Key",
          });
        }
        if (apivalue === "") {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: "Enter Value Here",
          });
        }
        if (resource === "") {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: "Enter Resource Url",
          });
        }
        res = await fetch(`${process.env.REACT_APP_BASE_API_URL}checkApiConnection`, {
          method: "POST",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            username: username,
            key: apikey,
            value: apivalue,
            resource: resource,
          },
          body: JSON.stringify({
            ConnectorName: "Azure Table Storage",
            authMethod: "APIKey",
            authDetails: {
              Key: apikey,
              Value: apivalue,
            },
            ResourceUrl: resource,
          }),
        });
      } else {
        if (clientid === "") {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: "Enter client id",
          });
        }
        if (clientsecret === "") {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: "Enter client secret",
          });
        }
        if (scope === "") {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: "Enter scope",
          });
        }
        if (accesstokenurl === "") {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: "Enter access token url",
          });
        }
        if (tenantid === "") {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: "Enter tenant id",
          });
        }
        if (resource === "") {
          setMyLoading(false);
          Swal.fire({
            icon: "error",
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            title: "Oops...",
            text: "Enter resource urls",
          });
        }
        res = await fetch(`${process.env.REACT_APP_BASE_API_URL}checkApiConnection`, {
          method: "POST",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            username: username,
          },
          body: JSON.stringify({
            ConnectorName: "Azure Table Storage",
            authMethod: "OAuth",
            authDetails: {
              type: "OAuth",
              AccessTokenUrl: accesstokenurl,
              ClientId: clientid,
              ClientSecret: clientsecret,
              Scope: scope,
              TenantId: tenantid,
            },
            storageAccountName: accountname,
            ResourceUrl: resource,
            tableName: tablename,
            query: query,
          }),
        });
      }

      if (res.status === 200) {
        const responseJson = await res.json();
        if (responseJson === true) {
          let res1;
          if (connectionType === "APIkey") {
            res1 = await fetch(`${process.env.REACT_APP_BASE_API_URL}getapifields`, {
              method: "POST",
              headers: {
                "Content-type": "application/json; charset=UTF-8",
                username: username,
                key: apikey,
                value: apivalue,
                resource: resource,
              },
              body: JSON.stringify({
                ConnectorName: "Azure Table Storage",
                authMethod: "APIKey",
                authDetails: {
                  Key: apikey,
                  Value: apivalue,
                },
                ResourceUrl: resource,
              }),
            });
          } else {
            res1 = await fetch(`${process.env.REACT_APP_BASE_API_URL}getapifields`, {
              method: "POST",
              headers: {
                "Content-type": "application/json; charset=UTF-8",
                username: username,
                key: apikey,
                value: apivalue,
                resource: resource,
              },
              body: JSON.stringify({
                ConnectorName: "Azure Table Storage",
                authMethod: "OAuth",
                authDetails: {
                  type: "OAuth",
                  AccessTokenUrl: accesstokenurl,
                  ClientId: clientid,
                  ClientSecret: clientsecret,
                  Scope: scope,
                  TenantId: tenantid,
                },
                storageAccountName: accountname,
                ResourceUrl: resource,
                tableName: tablename,
                query: query,
              }),
            });
          }
          if (res1.status === 200) {
            const responseJson1 = await res1.json();
            if (responseJson1.success == false) {
              setMyLoading(false);
              Swal.fire({
                icon: "error",
                iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
                title: "Oops...",
                text: responseJson.data,
              });
            } else if (responseJson1.status == 400) {
              setMyLoading(false);
              Swal.fire({
                icon: "error",
                iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
                title: "Oops...",
                text: responseJson.title,
              });
            } else {
              setMyLoading(false);
              Swal.fire({
                icon: "success",
                html: '<h4 style="color:#407775;font-size: 20px;">Success!</h4><p style="font-size:16px;">Connection Created successfully</p>',
                iconHtml: '<img src="assets/img/successicon.png" style="width: 55px; height: 55px;" />',
              });
              if (selectedExcel === "Azure Table Storage") {
                setAzureAPIMessage("Azure Table Storage");
                setAzureTableStorageFields(responseJson1);
              }
            }
          }
        } else {
          setMyLoading(false);
          setAzureAPIMessage("");
        }
      } else {
        setMyLoading(false);
      }
    } catch (err) {
      setMyLoading(false);
    }
  };

  const connectorData = [
    { type: "Excel", name: "Abc excel", fieldCount: 8 },
    { type: "API", name: "Xyz API", fieldCount: 10 },
  ];

  const onChangeESG = (e) => {
    fetchESGParameter(e);
  };
  const onChangeESGParameter = (e) => {
    fetchTopic(e);
  };
  const onChangeTopic = (e) => {
    fetchSubTopic(e);
  };
  const renderHeader = () => {
    const loginType = localStorage.getItem("loginType");
    if (loginType === "AAD") {
      return <AADHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} heading="" />;
    }
    return <LoginHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} heading="" />;
  };

  const [connectorNames, setConnectorNames] = useState({});
  const [currentDefaultRow, setCurrentDefaultRow] = useState(null);

  return (
    <React.Fragment>
      <div id="wrapper">
        <div>
          {myloading && (
            <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
              <CircularProgress color="inherit" />
            </Backdrop>
          )}
        </div>
        <div>
          <Toaster position="top-right" reverseOrder={false} />
        </div>
        {renderHeader()}
        <SideNavigation isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
        <div id="page-content-wrapper" className={isSidebarOpen ? "page-content-wrapper-pd-0" : "page-wrapper"}>
          <div className="steps__containt-body">
            {loading && <div class="loading">Loading&#8230;</div>}
            <div className="steps__containt-left">
              <Stepper activeStep={activeStep} orientation="vertical">
                {steps.map((step, index) => (
                  <Step key={step.label}>
                    <StepLabel
                      icon={
                        <Badge
                          className="badgeRoot badgeContent"
                          overlap="circular"
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "right",
                          }}
                          badgeContent={
                            <>
                              <img src={step.active <= count ? "./assets/img/Assets/configration_icon/White/Outer Circle.png" : iconDotInactive} alt="Outer Circle" className="outerCircle" />
                              <img src={step.active <= count ? "./assets/img/Assets/configration_icon/White/Inner circle.png" : iconBackgroundInactive} alt="Inner Circle" className={`${step.active <= count ? "innerCircle" : "innerCircleInactive"}`} />
                              <img src={customIcons[index]} alt={step.active <= count ? "Custom Icon" : "Inactive Icon"} className="customIcon" />
                            </>
                          }
                        >
                          <Avatar alt={`Step ${index + 1}`} className={`'avatar' ${step.active ? "activeIcon" : "inactiveIcon"}`} />
                        </Badge>
                      }
                    >
                      {step.label}
                    </StepLabel>
                    <StepContent>
                      <Typography>{step.description}</Typography>
                      <Box sx={{ mb: 2 }}>
                        <div></div>
                      </Box>
                    </StepContent>
                  </Step>
                ))}
              </Stepper>
            </div>
            <div className="revized__containt-right">
              {/* Step 1 */}
              {activeStep === 0 && (
                <div>
                  <div className="steps__containt-hader ml-4">
                    <h3 className="title">Select ESG Parameter</h3>
                    <p>Select the data parameter to set up the new connection.</p>
                  </div>
                  <hr style={{ borderBottom: "0.5px solid #707070", boxShadow: "0px 3px 6px #00000029", border: "0" }} />
                  <div className="revized__container">
                    <form>
                      <div className="row">
                        <div className="col-lg-7 col-md-7 col-sm-12 col-xs-12">
                          <div className="mb-3">
                            <label className="formlable">
                              ESG Selection <span className="mark-form">*</span>
                            </label>
                            <Dropdown
                              value={esg}
                              options={esgOptions}
                              onChange={(e) => {
                                setESG(e.value);
                                setMatrics(e.value);
                                fetchESGParameter(e.value); // loads ESG parameters via API
                                checkAppName2(e.value); // your existing helper
                              }}
                              placeholder="Select ESG"
                              className="p-inputtext-sm wd-100"
                              required
                            />
                          </div>
                          <div className="mb-3">
                            <label className="formlable">
                              ESG Parameter <span className="mark-form">*</span>
                            </label>
                            <Dropdown
                              value={esgParameter}
                              options={esgParamOptions}
                              onChange={(e) => {
                                setESGParameter(e.value);
                                fetchTopic(e.value); // loads Topics via API
                              }}
                              placeholder="Select ESG parameter"
                              className="p-inputtext-sm wd-100"
                              required
                            />
                          </div>
                          <div className="mb-3">
                            <label className="formlable">
                              Topic<span className="mark-form">*</span>
                            </label>
                            <Dropdown
                              value={topic}
                              options={topicOptions}
                              onChange={(e) => {
                                setTopic(e.value);
                                setMatrics(e.value);
                                fetchSubTopic(e.value); // loads Subtopics via API
                              }}
                              placeholder="Select topic"
                              className="p-inputtext-sm wd-100"
                              required
                            />
                          </div>
                          <div className="mb-3">
                            <label className="formlable">
                              Sub Topic<span className="mark-form"></span>
                            </label>
                            <Dropdown value={subTopic} options={subTopicOptions} onChange={(e) => setSubTopic(e.value)} placeholder="Select subtopic" className="p-inputtext-sm wd-100" required />
                          </div>
                          <div className="form-group mb-4">
                            <label className="formlable">
                              Parameter<span className="mark-form">*</span>
                            </label>

                            <div className="d-flex gap-4 mb-3">
                              <div className="d-flex align-items-center gap-2">
                                <RadioButton inputId="siteOption" name="parameterOption" value="site" onChange={(e) => setParameterOption(e.value)} checked={parameterOption === "site"} />
                                <label htmlFor="siteOption" style={{ fontSize: "14px", marginBottom: "0" }}>
                                  Site Location
                                </label>
                              </div>

                              <div className="d-flex align-items-center gap-2">
                                <RadioButton inputId="legalOption" name="parameterOption" value="legal" onChange={(e) => setParameterOption(e.value)} checked={parameterOption === "legal"} />
                                <label htmlFor="legalOption" style={{ fontSize: "14px", marginBottom: "0" }}>
                                  Legal Entity
                                </label>
                              </div>
                            </div>

                            {parameterOption === "site" && (
                              <div className="mb-3">
                                <label className="formlable">
                                  Site Location<span className="mark-form">*</span>
                                </label>
                                <Dropdown
                                  value={sitelocation1}
                                  options={siteLocationOptions}
                                  onChange={(e) => {
                                    setSiteLocation1(e.value);
                                    checkAppName1(e.value);
                                  }}
                                  placeholder="Select site location"
                                  className="p-inputtext-sm wd-100"
                                  required
                                />
                              </div>
                            )}

                            {parameterOption === "legal" && (
                              <div className="mt-3">
                                <label className="formlable">
                                  Legal Entity<span className="mark-form">*</span>
                                </label>
                                <Dropdown
                                  value={legalEntity}
                                  options={legalEntityOptions}
                                  onChange={(e) => {
                                    setLegalEntity(e.value);
                                    checkAppName1(e.value);
                                  }}
                                  placeholder="Select legal entity"
                                  className="p-inputtext-sm wd-100"
                                  required
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </form>
                    <div className="next__previous-buttons mt-0">
                      <div className="d-flex">
                        <Button
                          className="next-button"
                          onClick={handleNext}
                          variant="contained"
                          size="medium"
                          sx={{
                            color: "#fff",
                            backgroundColor: "#407775",
                            width: "120px",
                            height: "41px",
                            borderRadius: "10px",
                            textAlign: "center",
                          }}
                          // disabled={!esg || !esgParameter || !topic || (!sitelocation1 || !legalEntity)}
                          disabled={!esg || !esgParameter || !topic || (parameterOption === "site" ? !sitelocation1 : parameterOption === "legal" ? !legalEntity : true)}
                        >
                          Next
                          <p style={{ paddingTop: "17px" }}>&gt;</p>
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Step 2 */}
              {activeStep === 1 && (
                <div>
                  <div className="steps__containt-hader ml-4">
                    <h3 className="title">Edit Data Connectors</h3>
                    <p>Simplify data collection using import options such as excel sheets, XML files and API integration.</p>
                  </div>
                  <hr style={{ borderBottom: "0.5px solid #707070", boxShadow: "0px 3px 6px #00000029", border: "0" }} />
                  <div className="revized__container">
                    <div>
                      {/* <label className="form-label">
                        Choose connector <span className="mark-form">*</span>
                      </label> */}
                      <ul className="list dropzone__list">
                        {getappnames && getappnames.configuredAppNames.length === 0 ? (
                          <div></div>
                        ) : (
                          <div style={cardStyles.heading} className="text-conn">
                            Used connector
                          </div>
                        )}

                        {getappnames &&
                          getappnames.configuredAppNames.map((appname) => {
                            if (appname === "Excel") {
                              return (
                                // <li key={appname} className={selectedExcel.includes(appname) ? "active items" : "items"} value={appname}>
                                //   <label className="custom-checkbox" onClick={() => handleClick(appname)}>
                                //     <input
                                //       type="checkbox"
                                //       checked={selectedExcel.includes(appname)}
                                //       onChange={() => handleClick(appname)} // also handle change event
                                //     />
                                //     <span className="checkmark"></span>
                                //   </label>
                                //   <img src="assets/img/excel.png" onClick={() => handleClick(appname)} />
                                //   <h6 onClick={() => handleClick(appname)}>{appname}</h6>
                                // </li>
                                <li key={appname} className={selectedExcel.includes(appname) ? "active items" : "items"} onClick={() => handleClick(appname)}>
                                  <label className="custom-checkbox">
                                    <input type="checkbox" checked={selectedExcel.includes(appname)} onClick={(e) => e.stopPropagation()} readOnly />
                                    <span className="checkmark"></span>
                                  </label>
                                  <img src="assets/img/excel.png" />
                                  <h6>{appname}</h6>
                                </li>
                              );
                            }
                            if (appname === "PDF") {
                              return (
                                <li key={appname} className={selectedExcel.includes(appname) ? "active items" : "items"} value={appname} onClick={() => handleClick(appname)}>
                                  <label className="custom-checkbox">
                                    <input type="checkbox" checked={selectedExcel.includes(appname)} onClick={(e) => e.stopPropagation()} readOnly />
                                    <span className="checkmark"></span>
                                  </label>
                                  <img src="assets/img/pdf.png" />
                                  <h6>{appname}</h6>
                                </li>
                              );
                            }
                            if (appname === "Dynamics") {
                              return (
                                <li key={appname} className={selectedExcel.includes(appname) ? "active items" : "items"} value={appname} onClick={() => handleClick(appname)}>
                                  <label className="custom-checkbox">
                                    <input type="checkbox" checked={selectedExcel.includes(appname)} onClick={(e) => e.stopPropagation()} readOnly />
                                    <span className="checkmark"></span>
                                  </label>
                                  <img src="assets/img/dynamics.png" onClick={() => handleClick(appname)} />
                                  <h6>{appname}</h6>
                                </li>
                              );
                            }
                          })}

                        {getappnames && getappnames.availableToConfigureAppNames.length === 0 ? (
                          <div></div>
                        ) : (
                          <div style={cardStyles.heading} className="text-conn">
                            Add New Connector
                          </div>
                        )}

                        {getappnames &&
                          getappnames.availableToConfigureAppNames.map((appname) => {
                            if (appname === "Excel") {
                              return (
                                <li key={appname} className={selectedExcel.includes(appname) ? "active items" : "items"} value={appname} htmlFor={appname} onClick={() => handleClick(appname)}>
                                  <label class="custom-checkbox">
                                    <input type="checkbox" checked={selectedExcel.includes(appname)} onClick={(e) => e.stopPropagation()} readOnly />
                                    <span class="checkmark"></span>
                                  </label>
                                  <img src="assets/img/excel.png" />
                                  <h6>{appname}</h6>
                                </li>
                              );
                            }
                            if (appname === "PDF") {
                              return (
                                <li className={selectedExcel.includes(appname) ? "active items" : "items"} value={appname} onClick={() => handleClick(appname)}>
                                  <label class="custom-checkbox">
                                    <input type="checkbox" checked={selectedExcel.includes(appname)} onClick={(e) => e.stopPropagation()} readOnly />
                                    <span class="checkmark"></span>
                                  </label>
                                  <img src="assets/img/pdf.png" />
                                  <h6>{appname}</h6>
                                </li>
                              );
                            }
                            if (appname === "Dynamics") {
                              return (
                                <li className={selectedExcel.includes(appname) ? "active items" : "items"} value={appname} onClick={() => handleClick(appname)}>
                                  <label class="custom-checkbox">
                                    <input type="checkbox" checked={selectedExcel.includes(appname)} onClick={(e) => e.stopPropagation()} readOnly />
                                    <span class="checkmark"></span>
                                  </label>
                                  <img src="assets/img/dynamics.png" />
                                  <h6>{appname}</h6>
                                </li>
                              );
                            }
                          })}
                        {/* Cascading Connectors */}
                        {getappnames &&
                          getappnames.cascadesConnectors.map((appname) => {
                            if (appname.name === "Azure Table Storage") {
                              return (
                                <li className={selectedExcel.includes(appname.name) ? "active items" : "items"} value={appname.name} onClick={() => handleClick(appname.name)}>
                                  <label class="custom-checkbox">
                                    <input type="checkbox" checked={selectedExcel.includes(appname.name)} onClick={(e) => e.stopPropagation()} readOnly />
                                    <span class="checkmark"></span>
                                  </label>
                                  <img src="assets/img/azuretablestorage.png" />
                                  <h6>{appname.name}</h6>
                                </li>
                              );
                            }
                            if (appname.name === "API") {
                              return (
                                <li
                                  className={selectedExcel.includes(appname.name) ? "active items" : "items"}
                                  value={appname.name}
                                  onClick={() => {
                                    handleClick(appname.name);
                                  }}
                                >
                                  <label class="custom-checkbox">
                                    <input type="checkbox" checked={selectedExcel.includes(appname.name)} onClick={(e) => e.stopPropagation()} readOnly />
                                    <span class="checkmark"></span>
                                  </label>
                                  {/*<input
                                      type="checkbox"
                                      className="checkbox"
                                      checked={selectedExcel.includes(appname.name)}/>*/}
                                  <img src="assets/img/api.png" />
                                  <h6>{appname.name}</h6>
                                </li>
                              );
                            }
                          })}

                        {getappnames && getappnames.comingSoonAppNames.length === 0 ? (
                          <div></div>
                        ) : (
                          <div style={cardStyles.heading} className="text-conn">
                            Edit Existing Connector
                          </div>
                        )}

                        {getappnames &&
                          getappnames.comingSoonAppNames.map((appname) => {
                            if (appname === "Meter") {
                              return (
                                <li className="items">
                                  <img src="assets/img/meterno.png" />
                                  <h6>{appname}</h6>
                                </li>
                              );
                            }
                            if (appname === "SAP") {
                              return (
                                <li className="items">
                                  <img src="assets/img/sap.png" />
                                  <h6>{appname}</h6>
                                </li>
                              );
                            }
                            if (appname === "Oracle") {
                              return (
                                <li className="items">
                                  <img src="assets/img/oracle.png" />
                                  <h6>{appname}</h6>
                                </li>
                              );
                            }
                            if (appname === "Dynamics") {
                              return (
                                <li className="items">
                                  <img src="assets/img/dynamics.png" />
                                  <h6>{appname}</h6>
                                </li>
                              );
                            }
                            if (appname === "SalesForce") {
                              return (
                                <li className="items">
                                  <img src="assets/img/salesforce.png" />
                                  <h6>{appname}</h6>
                                </li>
                              );
                            }
                          })}
                      </ul>
                    </div>
                    <div className="next__previous-buttons">
                      <div className="d-flex gap-3">
                        <Button className="outline-btn" variant="outlined" onClick={handleBack}>
                          <p style={{ paddingTop: "17px", color: "#407775" }}>&lt;</p>
                          Back
                        </Button>
                        <Button variant="contained" color="primary" className="next-button" onClick={handleNext} disabled={!selectedExcel}>
                          Next <p style={{ paddingTop: "17px" }}>&gt;</p>
                        </Button>
                        <Button variant="contained" color="primary" className="next-button" onClick={handleNext} disabled={!selectedExcel}>
                          Skip <p style={{ paddingTop: "17px" }}>&gt;</p>
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Step 3 */}
              {activeStep === 2 && (
                <div>
                  <div className="steps__containt-hader ml-4">
                    <h3 className="title">Edit/ Create Connection</h3>
                    <p>Simply data collection using import options such as excel sheets, XML files and API integration.</p>
                  </div>
                  <hr style={{ borderBottom: "0.5px solid #707070", boxShadow: "0px 3px 6px #00000029", border: "0", marginBottom: "0" }} />
                  <div className="revized__side__container">
                    <div className="child-div-10">
                      {selectedExcel.map((excelType, index) => (
                        <div key={index} className={`clickable-div ${selectedDiv === excelType ? "selected" : ""}`} onClick={() => handleDivClick(excelType)}>
                          <img src={`assets/img/${excelType.toLowerCase().replace(/\s+/g, "")}.png`} alt={excelType} />
                          <label>{excelType}</label>
                        </div>
                      ))}
                    </div>
                    <div className="child-div-90">
                      {selectedExcel.map((excelType, index) =>
                        selectedDiv === excelType ? (
                          <div key={index} className="connector-content">
                            {excelType === "Excel" && (
                              <div>
                                {!importfile ? (
                                  <>
                                    <p style={{ color: "#707070" }}>Connect To Data Source</p>
                                    <label class="formlable" for="formGroupExampleInput">
                                      Connector Name <span className="mark-form">*</span>
                                    </label>
                                    <input
                                      type="text"
                                      name={`connectorName-${excelType}`}
                                      value={connectorNames[excelType] || ""}
                                      onChange={(e) =>
                                        setConnectorNames((prev) => ({
                                          ...prev,
                                          [excelType]: e.target.value,
                                        }))
                                      }
                                      className="form-control"
                                      required
                                      id="formGroupExampleInput"
                                      placeholder="Enter the required connector name"
                                    />
                                    <Dropzone onDrop={(acceptedFiles) => onDrop(acceptedFiles)}>
                                      {({ getRootProps, getInputProps }) => (
                                        <div className="dropzone__section">
                                          <div {...getRootProps()}>
                                            <input {...getInputProps()} />
                                            <div className="dropzone add-repo">
                                              <label for="files" class="dropzone-container"></label>
                                              <div className="upload-icon">
                                                <img class="icon" src="assets/img/reports/upload-file.svg" alt=""></img>
                                              </div>
                                              <p style={{ color: "#707070", fontSize: "14px" }}>
                                                <span style={{ color: "#407775", fontWeight: "600" }}>Browse</span> or drag and drop here
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </Dropzone>
                                  </>
                                ) : (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      maxWidth: "770px",
                                      width: "100%",
                                    }}
                                  >
                                    <div
                                      style={{
                                        background: "#F5F8F8",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        height: "300px",
                                        width: "100%",
                                        maxWidth: "770px",
                                        borderRadius: "10px",
                                      }}
                                    >
                                      <img
                                        src="assets/img/successicon.png"
                                        alt="Label 2"
                                        style={{
                                          width: "80px",
                                          height: "80px",
                                          marginBottom: "10px",
                                        }}
                                      />
                                      <label style={{ fontWeight: "600", size: "medium", color: "#407775", fontSize: "18px" }}>Success!</label>
                                      <p className="mb-0" style={{ color: "#707070" }}>
                                        {importfile}
                                      </p>
                                      <p style={{ color: "#707070" }}>Excel Connector Successfully added.</p>
                                    </div>
                                    <div className="d-flex justify-content-end mt-3">
                                      <Button
                                        className="refresh-cta"
                                        onClick={() => {
                                          setImportFile("");
                                        }}
                                      >
                                        + Add Another Excel
                                      </Button>
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}
                            {excelType === "PDF" && (
                              <div>
                                {!importpdffile && (
                                  <>
                                    <p style={{ color: "#707070" }}>Connect To Data Source</p>
                                    <label class="formlable" for="formGroupExampleInput">
                                      Connector Name <span className="mark-form">*</span>
                                    </label>
                                    <input
                                      type="text"
                                      name={`connectorName-${excelType}`}
                                      value={connectorNames[excelType] || ""}
                                      onChange={(e) =>
                                        setConnectorNames((prev) => ({
                                          ...prev,
                                          [excelType]: e.target.value,
                                        }))
                                      }
                                      className="form-control"
                                      required
                                      id="formGroupExampleInput"
                                      placeholder="Enter the required connector name"
                                    />

                                    <Dropzone onDrop={(acceptedFiles) => onDrop(acceptedFiles)}>
                                      {({ getRootProps, getInputProps }) => (
                                        <div className="dropzone__section">
                                          <div {...getRootProps()}>
                                            <input {...getInputProps()} />
                                            <div className="dropzone add-repo">
                                              <label for="files" class="dropzone-container"></label>
                                              <div className="upload-icon">
                                                <img class="icon" src="assets/img/reports/upload-file.svg" alt=""></img>
                                              </div>
                                              <p style={{ color: "#707070", fontSize: "14px" }}>
                                                <span style={{ color: "#407775", fontWeight: "600" }}>Browse</span> or drag and drop here
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </Dropzone>
                                  </>
                                )}
                                {importpdffile && (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      maxWidth: "770px",
                                      width: "100%",
                                    }}
                                  >
                                    <div
                                      style={{
                                        background: "#F5F8F8",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        height: "300px",
                                        width: "100%",
                                        maxWidth: "770px",
                                        borderRadius: "10px",
                                      }}
                                    >
                                      <img
                                        src="assets/img/successicon.png"
                                        alt="Label 2"
                                        style={{
                                          width: "80px",
                                          height: "80px",
                                          marginBottom: "10px",
                                        }}
                                      />
                                      <label style={{ fontWeight: "600", size: "medium", color: "#407775", fontSize: "18px" }}>Success!</label>
                                      <p className="mb-0" style={{ color: "#707070" }}>
                                        {importpdffile}
                                      </p>
                                      <p style={{ color: "#707070" }}>PDF Connector Successfully added.</p>
                                    </div>
                                    <div className="d-flex justify-content-end mt-3">
                                      <Button
                                        className="refresh-cta"
                                        onClick={() => {
                                          setImportPDFFile("");
                                        }}
                                      >
                                        + Add Another PDF
                                      </Button>
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}
                            {excelType === "API" && (
                              <div>
                                <p style={{ color: "#707070" }}>Connect To Data Source</p>
                                <label class="formlable" for="formGroupExampleInput">
                                  Connector Name <span className="mark-form">*</span>
                                </label>
                                <input
                                  type="text"
                                  name={`connectorName-${excelType}`}
                                  value={connectorNames[excelType] || ""}
                                  onChange={(e) =>
                                    setConnectorNames((prev) => ({
                                      ...prev,
                                      [excelType]: e.target.value,
                                    }))
                                  }
                                  className="form-control"
                                  required
                                  id="formGroupExampleInput"
                                  placeholder="Enter the required connector name"
                                />
                                <div className="form-group col-md-12" style={{ paddingLeft: "0px", paddingRight: "0px", maxWidth: "770px" }}>
                                  <div className="form-group">
                                    <label className="formlable" htmlFor="connectionType">
                                      Connection type <span className="mark-form">*</span>
                                    </label>
                                    <Dropdown
                                      id="connectionType"
                                      value={formData.connectionType}
                                      options={connectionTypeOptions}
                                      onChange={(e) => {
                                        setFormData((prevData) => ({
                                          ...prevData,
                                          connectionType: e.value,
                                        }));
                                        handleConnectionTypeChange(e); // if this is a function you defined
                                      }}
                                      placeholder="Select authorization type"
                                      className="p-inputtext-sm wd-100"
                                      required
                                    />
                                  </div>
                                  {formData.connectionType === "APIkey" && (
                                    <div className="form-group">
                                      <div style={{ color: "#1E4B7A" }}>{formData.apiAPIMessage ? <p>{formData.apiAPIMessage} Connection Created successfully</p> : null}</div>
                                      <div className="form-group">
                                        <label className="formlable" htmlFor="key">
                                          Key <span className="mark-form">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          onChange={(e) => {
                                            setFormData((prevData) => ({
                                              ...prevData,
                                              key: e.target.value,
                                            }));
                                          }}
                                          className="form-control"
                                          required
                                          id="key"
                                          placeholder="Enter key"
                                        />
                                      </div>
                                      <div className="form-group">
                                        <label className="formlable" htmlFor="value">
                                          Value<span className="mark-form">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          onChange={(e) => {
                                            setFormData((prevData) => ({
                                              ...prevData,
                                              value: e.target.value,
                                            }));
                                          }}
                                          className="form-control"
                                          required
                                          id="value"
                                          placeholder="Enter value"
                                        />
                                      </div>
                                      <div className="form-group">
                                        <label className="formlable" htmlFor="resourceUrl3">
                                          Resource URL <span className="mark-form">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          required
                                          id="resourceUrl"
                                          onChange={(e) => {
                                            setFormData((prevData) => ({
                                              ...prevData,
                                              resourceUrl: e.target.value,
                                            }));
                                          }}
                                          placeholder="Enter resource URL"
                                        />
                                      </div>
                                      <div className="d-flex justify-content-end mt-3">
                                        <Button className="refresh-cta d-flex align-items-center" type="submit" onClick={() => checkApiConnection("APIKey")}>
                                          <img
                                            src="assets/img/validate.svg"
                                            alt="Success Icon"
                                            style={{
                                              marginRight: "8px",
                                              height: "16px",
                                            }}
                                          />
                                          Validate Connection
                                        </Button>
                                      </div>
                                    </div>
                                  )}

                                  {formData.connectionType === "OAuth" && (
                                    <div className="form-group">
                                      <div className="form-group">
                                        <label className="formlable" htmlFor="query">
                                          Query<span className="mark-form">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          onChange={(e) => {
                                            setQuery(e.target.value);
                                          }}
                                          className="form-control"
                                          required
                                          id="query"
                                          placeholder="Enter your query"
                                        />
                                      </div>
                                      <div className="form-group">
                                        <label className="formlable" htmlFor="accessTokenUrl">
                                          Access Token URL<span className="mark-form">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          onChange={(e) => {
                                            setAccessTokenUrl(e.target.value);
                                          }}
                                          className="form-control"
                                          required
                                          id="accessTokenUrl"
                                          placeholder="Enter access token URL"
                                        />
                                      </div>
                                      <div className="form-group">
                                        <label className="formlable" htmlFor="clientId">
                                          Client Id<span className="mark-form">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          onChange={(e) => {
                                            setClientID(e.target.value);
                                          }}
                                          className="form-control"
                                          required
                                          id="clientId"
                                          placeholder="Enter client ID"
                                        />
                                      </div>
                                      <div className="form-group">
                                        <label className="formlable" htmlFor="clientSecret">
                                          Client Secret <span className="mark-form">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          onChange={(e) => {
                                            setClientSecret(e.target.value);
                                          }}
                                          className="form-control"
                                          required
                                          id="clientSecret"
                                          placeholder="Enter client secret"
                                        />
                                      </div>
                                      <div className="form-group">
                                        <label className="formlable" htmlFor="scope">
                                          Scope <span className="mark-form">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          onChange={(e) => {
                                            setScope(e.target.value);
                                          }}
                                          className="form-control"
                                          required
                                          id="scope"
                                          placeholder="Enter required scope"
                                        />
                                      </div>
                                      <div className="form-group">
                                        <label className="formlable" htmlFor="tenantId">
                                          Tenant Id <span className="mark-form">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          onChange={(e) => {
                                            setTenantID(e.target.value);
                                          }}
                                          className="form-control"
                                          required
                                          id="tenantId"
                                          placeholder="Enter tenant ID"
                                        />
                                      </div>
                                      <div className="form-group">
                                        <label className="formlable" htmlFor="resourceUrl4">
                                          Resource URL <span className="mark-form">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          onChange={(e) => {
                                            setResource(e.target.value);
                                          }}
                                          className="form-control"
                                          required
                                          id="resourceUrl"
                                          placeholder="Enter resource URL"
                                        />
                                      </div>
                                      <div className="d-flex justify-content-end mt-3">
                                        <Button className="refresh-cta d-flex align-items-center" type="submit" onClick={() => checkApiConnection("OAuth")}>
                                          <img
                                            src="assets/img/validate.svg"
                                            alt="Success Icon"
                                            style={{
                                              marginRight: "8px",
                                              height: "16px",
                                            }}
                                          />
                                          Validate Connection
                                        </Button>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                            {excelType === "Azure Table Storage" && (
                              <div>
                                <p style={{ color: "#707070" }}>Connect To Data Source</p>
                                <label class="formlable" for="formGroupExampleInput">
                                  Connector Name <span className="mark-form">*</span>
                                </label>
                                <input
                                  type="text"
                                  name={`connectorName-${excelType}`}
                                  value={connectorNames[excelType] || ""}
                                  onChange={(e) =>
                                    setConnectorNames((prev) => ({
                                      ...prev,
                                      [excelType]: e.target.value,
                                    }))
                                  }
                                  className="form-control"
                                  required
                                  id="formGroupExampleInput"
                                  placeholder="Enter the required connector name"
                                />
                                <div className="form-group col-md-12" style={{ paddingLeft: "0px", paddingRight: "0px", maxWidth: "770px" }}>
                                  <div className="form-group">
                                    <label className="formlable" htmlFor="connectionType">
                                      Connection type <span className="mark-form">*</span>
                                    </label>
                                    <Dropdown
                                      id="connectionType"
                                      value={connectionType}
                                      options={connectionTypeOptions}
                                      onChange={(e) => {
                                        setConnectionType(e.value);
                                        handleConnectionTypeChange(e); // if this is a function you defined
                                      }}
                                      placeholder="Select authorization type"
                                      className="p-inputtext-sm wd-100"
                                      required
                                    />
                                  </div>
                                  {connectionType === "APIkey" && (
                                    <div className="form-group">
                                      <div style={{ color: "#1E4B7A" }}>{azureAPIMessage ? <p>{azureAPIMessage} Connection Created successfully</p> : null}</div>
                                      {selectedExcel.includes("API") && (
                                        <div>
                                          <div className="form-group"></div>
                                          <div className="form-group">
                                            <label className="formlable" htmlFor="query">
                                              Query<span className="mark-form"></span>
                                            </label>
                                            <input
                                              type="text"
                                              onChange={(e) => {
                                                setQuery(e.target.value);
                                              }}
                                              className="form-control"
                                              id="query"
                                              placeholder="Enter your query"
                                            />
                                          </div>
                                        </div>
                                      )}
                                      {selectedExcel.includes("Azure Table Storage") && (
                                        <>
                                          <div className="form-group">
                                            <label className="formlable" htmlFor="storageAccountName">
                                              Storage Account Name<span className="mark-form">*</span>
                                            </label>
                                            <input
                                              type="text"
                                              onChange={(e) => {
                                                setAccoutName(e.target.value);
                                              }}
                                              className="form-control"
                                              required
                                              id="storageAccountName"
                                              placeholder="Enter storage account name"
                                            />
                                          </div>
                                          <div className="form-group">
                                            <label className="formlable" htmlFor="tableName">
                                              Table Name<span className="mark-form">*</span>
                                            </label>
                                            <input
                                              type="text"
                                              onChange={(e) => {
                                                setTableName(e.target.value);
                                              }}
                                              className="form-control"
                                              required
                                              id="tableName"
                                              placeholder="Enter table name"
                                            />
                                          </div>
                                          <div className="form-group">
                                            <label className="formlable" htmlFor="query">
                                              Query<span className="mark-form"></span>
                                            </label>
                                            <input
                                              type="text"
                                              onChange={(e) => {
                                                setQuery(e.target.value);
                                              }}
                                              className="form-control"
                                              id="query"
                                              placeholder="Enter your query"
                                            />
                                          </div>
                                        </>
                                      )}
                                      <div className="form-group">
                                        <label className="formlable" htmlFor="key">
                                          Key <span className="mark-form">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          onChange={(e) => {
                                            setApiKey(e.target.value);
                                          }}
                                          className="form-control"
                                          required
                                          id="key"
                                          placeholder="Enter key"
                                        />
                                      </div>
                                      <div className="form-group">
                                        <label className="formlable" htmlFor="value">
                                          Value<span className="mark-form">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          onChange={(e) => {
                                            setApiValue(e.target.value);
                                          }}
                                          className="form-control"
                                          required
                                          id="value"
                                          placeholder="Enter value"
                                        />
                                      </div>
                                      <div className="form-group">
                                        <label className="formlable" htmlFor="resourceUrl3">
                                          Resource URL <span className="mark-form">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          required
                                          id="resourceUrl"
                                          onChange={(e) => {
                                            setResource(e.target.value);
                                          }}
                                          placeholder="Enter resource URL"
                                        />
                                      </div>
                                      <div className="d-flex justify-content-end mt-3">
                                        <Button className="refresh-cta d-flex align-items-center" type="submit" onClick={() => checkAzureConnection("API")}>
                                          <img
                                            src="assets/img/validate.svg"
                                            alt="Success Icon"
                                            style={{
                                              marginRight: "8px",
                                              height: "16px",
                                            }}
                                          />
                                          Validate Connection
                                        </Button>
                                      </div>
                                    </div>
                                  )}

                                  {connectionType === "OAuth" && (
                                    <div className="form-group">
                                      {selectedExcel.includes("API") && (
                                        <div className="form-group">
                                          <label className="formlable" htmlFor="query">
                                            Query<span className="mark-form">*</span>
                                          </label>
                                          <input
                                            type="text"
                                            onChange={(e) => {
                                              setQuery(e.target.value);
                                            }}
                                            className="form-control"
                                            required
                                            id="query"
                                            placeholder="Enter your query"
                                          />
                                        </div>
                                      )}
                                      {selectedExcel.includes("Azure Table Storage") && (
                                        <>
                                          <div className="form-group">
                                            <label className="formlable" htmlFor="storageAccountName">
                                              Storage Account Name<span className="mark-form">*</span>
                                            </label>
                                            <input
                                              type="text"
                                              onChange={(e) => {
                                                setAccoutName(e.target.value);
                                              }}
                                              className="form-control"
                                              required
                                              id="storageAccountName"
                                              placeholder="Enter storage account name"
                                            />
                                          </div>
                                          <div className="form-group">
                                            <label className="formlable" htmlFor="tableName">
                                              Table Name<span className="mark-form">*</span>
                                            </label>
                                            <input
                                              type="text"
                                              onChange={(e) => {
                                                setTableName(e.target.value);
                                              }}
                                              className="form-control"
                                              required
                                              id="tableName"
                                              placeholder="Enter table name"
                                            />
                                          </div>
                                          <div className="form-group">
                                            <label className="formlable" htmlFor="query">
                                              Query<span className="mark-form">*</span>
                                            </label>
                                            <input
                                              type="text"
                                              onChange={(e) => {
                                                setQuery(e.target.value);
                                              }}
                                              className="form-control"
                                              required
                                              id="query"
                                              placeholder="Enter your query"
                                            />
                                          </div>
                                        </>
                                      )}

                                      <div className="form-group">
                                        <label className="formlable" htmlFor="accessTokenUrl">
                                          Access Token URL<span className="mark-form">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          onChange={(e) => {
                                            setAccessTokenUrl(e.target.value);
                                          }}
                                          className="form-control"
                                          required
                                          id="accessTokenUrl"
                                          placeholder="Enter access token URL"
                                        />
                                      </div>

                                      <div className="form-group">
                                        <label className="formlable" htmlFor="clientId">
                                          Client Id<span className="mark-form">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          onChange={(e) => {
                                            setClientID(e.target.value);
                                          }}
                                          className="form-control"
                                          required
                                          id="clientId"
                                          placeholder="Enter client ID"
                                        />
                                      </div>

                                      <div className="form-group">
                                        <label className="formlable" htmlFor="clientSecret">
                                          Client Secret <span className="mark-form">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          onChange={(e) => {
                                            setClientSecret(e.target.value);
                                          }}
                                          className="form-control"
                                          required
                                          id="clientSecret"
                                          placeholder="Enter client secret"
                                        />
                                      </div>

                                      <div className="form-group">
                                        <label className="formlable" htmlFor="scope">
                                          Scope <span className="mark-form">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          onChange={(e) => {
                                            setScope(e.target.value);
                                          }}
                                          className="form-control"
                                          required
                                          id="scope"
                                          placeholder="Enter required scope"
                                        />
                                      </div>

                                      <div className="form-group">
                                        <label className="formlable" htmlFor="tenantId">
                                          Tenant Id <span className="mark-form">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          onChange={(e) => {
                                            setTenantID(e.target.value);
                                          }}
                                          className="form-control"
                                          required
                                          id="tenantId"
                                          placeholder="Enter tenant ID"
                                        />
                                      </div>

                                      <div className="form-group">
                                        <label className="formlable" htmlFor="resourceUrl4">
                                          Resource URL <span className="mark-form">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          onChange={(e) => {
                                            setResource(e.target.value);
                                          }}
                                          className="form-control"
                                          required
                                          id="resourceUrl"
                                          placeholder="Enter resource URL"
                                        />
                                      </div>

                                      {connectionType === "OAuth" && (
                                        <div className="d-flex justify-content-end mt-3">
                                          <Button className="refresh-cta d-flex align-items-center" type="submit" onClick={() => checkAzureConnection("Azure Table Storage")}>
                                            <img
                                              src="assets/img/validate.svg"
                                              alt="Success Icon"
                                              style={{
                                                marginRight: "8px",
                                                height: "16px",
                                              }}
                                            />
                                            Validate Connection
                                          </Button>
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        ) : null
                      )}
                      <div className="next__previous-buttons">
                        <div className="d-flex gap-3">
                          <Button className="outline-btn" variant="outlined" onClick={handleBack}>
                            Back
                          </Button>
                          <Button variant="contained" color="primary" className="next-button" onClick={handleNext} disabled={!importfile}>
                            Next
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Step 4 */}
              {activeStep === 3 && (
                <div className="">
                  <div className="data__table">
                    <div className="steps__containt-hader ml-4">
                      <h3 className="title">Edit Field Mapping</h3>
                      <p>Map the fields from the data source to the attributes of the standard Ecoprism data requirement.</p>
                    </div>
                    <hr style={{ borderBottom: "0.5px solid #707070", boxShadow: "0px 3px 6px #00000029", border: "0" }} />
                    <div className="revized__container">
                      <div className="data-responsive config-table">
                        <DataTable value={excelfields} responsiveLayout="scroll" className="p-datatable-sm">
                          <Column
                            header="Data Requirement"
                            headerStyle={{ paddingLeft: "20px" }}
                            body={(rowData) => (
                              <div style={{ paddingLeft: "14px", fontSize: "14px" }}>
                                {rowData.key.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/^./, (str) => str.toUpperCase())}
                                {rowData.value && <span style={{ color: "red" }}>*</span>}
                                <input type="hidden" value={rowData.key} name="destination[]" data-label={rowData.key} />
                              </div>
                            )}
                          />

                          <Column
                            header="Connector"
                            body={(rowData, options) => (
                              <>
                                <Dropdown
                                  id={`connectord${options.rowIndex}`}
                                  value={selectedConnectors[options.rowIndex] || ""}
                                  options={selectedExcel.map((h) => ({ label: h, value: h }))}
                                  onChange={(e) => {
                                    const updated = [...selectedConnectors];
                                    updated[options.rowIndex] = e.value;
                                    setSelectedConnectors(updated);
                                    document.getElementById(`connector${options.rowIndex}`).value = e.value;
                                  }}
                                  placeholder="None"
                                  className="p-inputtext-sm wd-100"
                                  required={rowData.value === true}
                                  style={{ width: "200px", minWidth: "200px", maxWidth: "250px" }}
                                />
                                <input type="hidden" id={`connector${options.rowIndex}`} value="None" name="connectors[]" />
                              </>
                            )}
                          />
                          <Column
                            header="Field in Data Source"
                            body={(rowData, options) => (
                              <>
                                <Dropdown
                                  id={`dropdown${options.rowIndex}`}
                                  inputId={`dropdown${options.rowIndex}`}
                                  name="excelHeaderss[]"
                                  value={selectedOptions[options.rowIndex] || ""}
                                  options={
                                    selectedConnectors[options.rowIndex] === "Excel"
                                      ? headerfields.map((h) => ({
                                          label: h,
                                          value: h,
                                          disabled: selectedOptions.includes(h) && selectedOptions[options.rowIndex] !== h,
                                        }))
                                      : selectedConnectors[options.rowIndex] === "PDF"
                                      ? pdffields.map((h) => ({
                                          label: disambiguateSourceLabel(h, pdfSourceLabels, pdffields),
                                          value: h,
                                          disabled: selectedOptions.includes(h) && selectedOptions[options.rowIndex] !== h,
                                        }))
                                      : selectedConnectors[options.rowIndex] === "Azure Table Storage"
                                      ? azureTableStoragefields.map((h) => ({
                                          label: h,
                                          value: h,
                                          disabled: selectedOptions.includes(h) && selectedOptions[options.rowIndex] !== h,
                                        }))
                                      : selectedConnectors[options.rowIndex] === "API"
                                      ? apifields.map((h) => ({
                                          label: h,
                                          value: h,
                                          disabled: selectedOptions.includes(h) && selectedOptions[options.rowIndex] !== h,
                                        }))
                                      : []
                                  }
                                  onChange={(e) => excelH(e.value, options.rowIndex)}
                                  placeholder="Field Name"
                                  className="p-inputtext-sm wd-100"
                                  required={rowData.value === true}
                                  style={{ width: "250px", minWidth: "200px", maxWidth: "350px" }}
                                  disabled={!selectedConnectors[options.rowIndex]}
                                />
                                <input type="hidden" id={`excel${options.rowIndex}`} value={selectedOptions[options.rowIndex] || ""} name="excelHeaders[]" data-label={rowData.key} />
                                <div className="d-flex justify-content-end mt-2">
                                  <Button className="refresh-cta d-flex align-items-center" type="button" onClick={() => handleOpenDefaultModal(rowData)}>
                                    + Add Default Value
                                  </Button>
                                </div>
                              </>
                            )}
                          />
                        </DataTable>
                      </div>
                    </div>
                  </div>
                  <div className="next__previous-buttons pl-4">
                    <div className="d-flex gap-3">
                      <Button className="outline-btn" variant="outlined" onClick={handleBack}>
                        Back
                      </Button>
                      <Button variant="contained" color="primary" className="next-button" onClick={handleNext}>
                        Next
                      </Button>
                    </div>
                    <div class="ab"></div>
                  </div>
                </div>
              )}

              {/* Step 5 */}
              {activeStep === 4 && (
                <div ref={containerRef}>
                  <div className="revized__containt-header">
                    <h3 className="title">Review Data Connection</h3>
                    <p>Review your data connection ensuring seamless integration and optimal performance</p>
                  </div>
                  <div className="revized_second_steps__container">
                    <div class="finish">
                      <p>
                        <strong>ESG parameter:</strong> {topic}
                      </p>
                      <p>
                        <strong>Site:</strong> {sitelocation1}
                      </p>
                      <p>
                        <strong>Owner:</strong> {username}
                      </p>

                      <p>
                        <span className="me-2">
                          <strong>Data Frequency:</strong>
                        </span>
                        <Dropdown value={dataFrequency} options={frequencyOptions} onChange={(e) => setDataFrequency(e.value)} placeholder="Select Frequency" className="p-inputtext-sm" style={{ width: "25%" }} />
                      </p>
                    </div>
                    <div className="steps__container survey-form">
                      <div className="data-responsive">
                        <DataTable
                          value={selectedExcel.map((connector, index) => ({
                            id: index,
                            connector,
                            connectorName: connectorNames[connector] || "",
                            fieldCount: Array.isArray(selectedConnectors) ? selectedConnectors.filter((item) => item === connector).length : 0,
                          }))}
                          className="p-datatable-sm"
                          responsiveLayout="scroll"
                        >
                          <Column field="connector" header="Data Connector" headerStyle={{ paddingLeft: "20px" }} body={(rowData) => <div style={{ paddingLeft: "14px" }}>{rowData.connector}</div>} />
                          <Column field="connectorName" header="Connector Name" />
                          <Column field="fieldCount" header="No of Fields" />
                        </DataTable>
                      </div>
                    </div>
                    <div className="next__previous-buttons">
                      <div className="d-flex">
                        <Button
                          onClick={handleBack}
                          variant="outlined"
                          size="medium"
                          className="outline-btn"
                          sx={{
                            color: "#000",
                            marginRight: "15px",
                            width: "120px",
                            height: "41px",
                            borderRadius: "10px",
                          }}
                        >
                          Back
                        </Button>
                        <Button
                          className="next-button"
                          onClick={handleSubmit}
                          variant="contained"
                          size="medium"
                          sx={{
                            color: "#fff",
                            backgroundColor: "#407775",
                            width: "120px",
                            height: "41px",
                            borderRadius: "10px",
                          }}
                        >
                          Save
                        </Button>
                        {/* <Button onClick={handleCancel} variant="outlined" size="medium" className="outline-btn" sx={{ 'color' : '#000', marginLeft :'20px', position: 'relative', width: '120px', height: '41px', borderRadius: '10px' }}>Cancel</Button> */}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Step 6 */}
              {activeStep === 5 && (
                <div>
                  <div className="steps__containt-hader ml-4">
                    <h3 className="title">Data connection</h3>
                    <p>The connection has been established and is now accessible in the configuration list</p>
                  </div>
                  <hr style={{ borderBottom: "0.5px solid #707070", boxShadow: "0px 3px 6px #00000029", border: "0" }} />
                  <div className="steps__container">
                    <div class="col-md-3"></div>
                    <div class="finish1">
                      <p>Connection created successfully</p>
                      {activeStep === steps.length && (
                        <Paper className="finish" square elevation={0} sx={{ p: 3 }}>
                          {/* <Typography>All steps completed - you&apos;re finished</Typography> */}
                          <Button
                            sx={{
                              color: "#fff",
                              backgroundColor: "#407775",
                              width: "120px",
                              height: "41px",
                              borderRadius: "10px",
                            }}
                            onClick={handleReset}
                            style={{ mt: 1, mr: 1 }}
                          >
                            <Link to="/allconfiguration" className="btn btn-primary config-btn">
                              All Configurations
                            </Link>
                          </Button>
                        </Paper>
                      )}
                    </div>
                    <div class="col-md-3"></div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <Modal show={showDefaultModal} onHide={handleCloseDefaultModal} centered className="custom-modal-width reports-modal add-default-value-modal">
          <Modal.Header className="justify-content-between">
            <Modal.Title>Add Default Value</Modal.Title>
            <Button variant="link" className="close-modal-button" onClick={handleCloseDefaultModal} style={{ padding: "0", minWidth: "0" }}>
              <IoIosCloseCircleOutline style={{ color: "white", fontSize: "24px" }} />
            </Button>
          </Modal.Header>
          <Modal.Body>
            <div style={{ display: "flex", justifyContent: "space-between", gap: "1rem" }}>
              <div style={{ flex: 1 }}>
                <label className="formlable">Data Requirement</label>
                <p style={{ marginTop: "8px" }}>{currentDefaultRow ? currentDefaultRow.key.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/^./, (str) => str.toUpperCase()) : ""}</p>
              </div>
              <div style={{ flex: 1 }}>
                <label className="formlable">Default Value</label>
                <input type="text" placeholder={currentDefaultRow ? currentDefaultRow.key.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/^./, (str) => str.toUpperCase()) : ""} className="form-control" />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button className="outline-btn" variant="outlined" onClick={handleCloseDefaultModal}>
              Cancel
            </Button>
            <Button variant="contained" color="primary" className="next-button" onClick={handleSaveDefaultValue}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </React.Fragment>
  );
}
